/* tslint:disable */
/* eslint-disable */
/**
 * Ampersand public API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { UseSalesforceFlowsConfig } from './UseSalesforceFlowsConfig';
import {
    UseSalesforceFlowsConfigFromJSON,
    UseSalesforceFlowsConfigFromJSONTyped,
    UseSalesforceFlowsConfigToJSON,
} from './UseSalesforceFlowsConfig';

/**
 * Subscribe options that apply to the whole installation and only to certain providers. Each option documents which providers support it; setting one for a provider that does not support it is rejected. For options that are set per object, see `subscribe.objects.<name>.providerOptions`.
 * @export
 * @interface SubscribeInstallationProviderOptions
 */
export interface SubscribeInstallationProviderOptions {
    /**
     * 
     * @type {UseSalesforceFlowsConfig}
     * @memberof SubscribeInstallationProviderOptions
     */
    useSalesforceFlows?: UseSalesforceFlowsConfig;
}

/**
 * Check if a given object implements the SubscribeInstallationProviderOptions interface.
 */
export function instanceOfSubscribeInstallationProviderOptions(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function SubscribeInstallationProviderOptionsFromJSON(json: any): SubscribeInstallationProviderOptions {
    return SubscribeInstallationProviderOptionsFromJSONTyped(json, false);
}

export function SubscribeInstallationProviderOptionsFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubscribeInstallationProviderOptions {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'useSalesforceFlows': !exists(json, 'useSalesforceFlows') ? undefined : UseSalesforceFlowsConfigFromJSON(json['useSalesforceFlows']),
    };
}

export function SubscribeInstallationProviderOptionsToJSON(value?: SubscribeInstallationProviderOptions | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'useSalesforceFlows': UseSalesforceFlowsConfigToJSON(value.useSalesforceFlows),
    };
}

